import { render, staticRenderFns } from "./group-checkbox-control.vue?vue&type=template&id=40c0bb32"
import script from "./group-checkbox-control.vue?vue&type=script&lang=js"
export * from "./group-checkbox-control.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports